<template>
    <div class="dataB-dataCollection-con">
        <div class="main">
            <div class="tit">
                <span class="btn-post">POST</span>
                <span>/collection/upload/{{ entityId }} 上传数据接口地址</span>
            </div>
            <div class="parameters">
                Parameters
            </div>
            <div class="parameters-con">
                <div class="tit">
                    <span class="head-name">Name</span>
                    <span class="description">Description</span>
                </div>
                <div class="item">
                    <div class="item-left">
                        <span>entity_id</span>
                        <span class="required">*required</span>
                    </div>
                    <div class="item-right">
                        数据实例id
                    </div>
                </div>
                <div class="item">
                    <div class="item-left">
                        <span>input</span>
                    </div>
                    <div class="item-right">
                        <h4>Example Value</h4>
                        <div class="parameters-input">
                            <el-input type="textarea" v-model="parametersStr" readonly></el-input>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        entityId: {
            type: String,
        },
    },
    data() {
        return {
            parametersStr: '',
        };
    },
    watch: {
        entityId(val) {
            this.entityId = val;
            this.parametersStr = '';
            if (!this.entityId) {
                // this.$message.warning('请先选择树节点');
                return;
            }
            this.getParameters();
        },
    },
    computed: {
    },
    methods: {
        getParameters() {
            this.$axios
                .get('/interfaceApi/datacenter/interface/collection/example/' + this.entityId)
                .then(res => {
                    if (res) {
                        this.parametersStr = res;
                    }
                })
                .catch(error => {
                    this.$message.error(error.ErrorCode.Message);
                });
        },
    },
    created() {
        if (!this.entityId) {
            // this.$message.warning('请先选择树节点');
            return;
        }
        this.parametersStr = '';
        this.getParameters();
    },
    mounted() {},
};
</script>
<style lang="stylus">
.dataB-dataCollection-con
    float left
    width calc(100% - 230px)
    height 100%
    background #fff
    margin-left 10px
    padding 20px
    .main
        height 100%
        border 1px solid #49cc90
        border-radius 3px
        .tit
            height 40px
            border-bottom 1px solid #49cc90
            .btn-post
                display inline-block
                width 80px
                height 30px
                text-align center
                line-height 30px
                color #fff
                background #49cc90
                border-radius 3px
                margin 5px 20px
        .parameters
            height 50px
            border-bottom 2px solid #d8e5df
            padding-left 20px
            line-height 50px
        .parameters-con
            padding 15px
            background #e8f6f0
            overflow hidden
            .tit
                border-bottom 1px solid #c6d2d0
                line-height 38px
                .head-name
                    width 400px
                    display inline-block
                .description
                    display inline-block
                    width calc(100% - 400px)
            .item
                line-height 38px
                .item-left
                    width 400px
                    float left
                    .required
                        color red
                .item-right
                    width calc(100% - 400px)
                    float left
                    .parameters-input
                        background #41444e
                        border-radius 3px
                        padding 10px
                        color #fff
                        textarea
                            min-height 300px!important
                            background #41444e
                            color #fff
                            border none

</style>